const getLabsAuthorized = (store) => {
  return store.labsAuthorized;
};

export { getLabsAuthorized };
